export default __webpack_public_path__ + "soon.jpg";